import React from 'react';
import { HeroBanner } from '../components/HeroBanner';
import { Phone, Mail, Clock } from 'lucide-react';
export function AppointmentPage() {
  return <div className="flex flex-col w-full" data-id="element-199" data-mp="aquifumcmpit">
      <HeroBanner title="REQUEST AN ESTIMATE" subtitle="Fill out the form below and our team will contact you to schedule a free, no-obligation estimate." data-id="element-200" data-mp="5tb2mqa064or" />

      <section className="py-20 px-4 bg-slate-50" data-id="element-201" data-mp="3syjy7nui5x5o">
        <div className="max-w-7xl mx-auto" data-id="element-202" data-mp="3t03evfk2ma7z">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-203" data-mp="3o7tu0dxtc0ck">
            {/* Form Area */}
            <div className="lg:col-span-2 bg-white rounded-2xl shadow-sm border border-slate-200 p-8 sm:p-10" data-id="element-204" data-mp="3j8qnsq63jo30">
              <h2 className="text-2xl font-bold text-[#0c2340] mb-8" data-id="element-205" data-mp="3e9w31iokjpg9">
                Project Details
              </h2>

              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-206" data-mp="399hvs2uskjja">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-207" data-mp="358fvrjt1w3g9">
                  <div className="space-y-2" data-id="element-208" data-mp="35bbuvbgmwy6a">
                    <label htmlFor="firstName" className="block text-sm font-medium text-slate-700" data-id="element-209" data-mp="1yefum2ukqk29">
                      First Name
                    </label>
                    <input type="text" id="firstName" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="John" data-id="element-210" data-mp="1oj4fvkj61cui" />
                  </div>
                  <div className="space-y-2" data-id="element-211" data-mp="28623vtncq92d">
                    <label htmlFor="lastName" className="block text-sm font-medium text-slate-700" data-id="element-212" data-mp="287d6hq529arw">
                      Last Name
                    </label>
                    <input type="text" id="lastName" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="Doe" data-id="element-213" data-mp="10rqnjel0lh9j" />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-214" data-mp="2tmhqz31q5g9s">
                  <div className="space-y-2" data-id="element-215" data-mp="2oopyo7x63s52">
                    <label htmlFor="email" className="block text-sm font-medium text-slate-700" data-id="element-216" data-mp="2knwenpmuixhg">
                      Email Address
                    </label>
                    <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="john@example.com" data-id="element-217" data-mp="2aox4g2mfmtsc" />
                  </div>
                  <div className="space-y-2" data-id="element-218" data-mp="cg9dq8ryjr1u">
                    <label htmlFor="phone" className="block text-sm font-medium text-slate-700" data-id="element-219" data-mp="cfhsnrvzlbpt">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="(714) 555-0123" data-id="element-220" data-mp="l9cwmwldgw3v" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-221" data-mp="2gii23rnv606">
                  <label htmlFor="address" className="block text-sm font-medium text-slate-700" data-id="element-222" data-mp="7h6fp8aeal3d">
                    Property Address
                  </label>
                  <input type="text" id="address" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="123 Main St, City, Zip" data-id="element-223" data-mp="1ivtr7u2q0vlx" />
                </div>

                <div className="space-y-2" data-id="element-224" data-mp="30rlrxzfn8p6o">
                  <label htmlFor="service" className="block text-sm font-medium text-slate-700" data-id="element-225" data-mp="2vulvmg8lj0sr">
                    Service Needed
                  </label>
                  <select id="service" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow bg-white" data-id="element-226" data-mp="35s9v1jh5cwh9">
                    <option value="" data-id="element-227" data-mp="3tidudenaya2g">Select a service...</option>
                    <option value="new-install" data-id="element-228" data-mp="3tgjb04roiq0h">New Gutter Installation</option>
                    <option value="replacement" data-id="element-229" data-mp="3ol3ybg5er05n">Gutter Replacement</option>
                    <option value="guards" data-id="element-230" data-mp="bzopq5g4jqc6">
                      Gutter Guards / Leaf Protection
                    </option>
                    <option value="repair" data-id="element-231" data-mp="gyjbng9e1v0i">Gutter Repair</option>
                    <option value="cleaning" data-id="element-232" data-mp="22k4q8y0m0wy">Maintenance / Cleaning</option>
                    <option value="other" data-id="element-233" data-mp="70lmmqjpfu6u">Other</option>
                  </select>
                </div>

                <div className="space-y-2" data-id="element-234" data-mp="3pf4lez9ugs4o">
                  <label htmlFor="message" className="block text-sm font-medium text-slate-700" data-id="element-235" data-mp="3pda19n6ed41n">
                    Additional Details
                  </label>
                  <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow resize-none" placeholder="Tell us about your project..." data-id="element-236" data-mp="3feki7r2rldjt"></textarea>
                </div>

                <button type="submit" className="w-full bg-[#0c2340] hover:bg-[#0a1c33] text-white font-bold py-4 px-8 rounded-lg transition-colors" data-id="element-237" data-mp="1h069wjl965ci">
                  Submit Request
                </button>
              </form>
            </div>

            {/* Sidebar Info */}
            <div className="space-y-8" data-id="element-238" data-mp="1zxphrjvz5hxc">
              <div className="bg-[#0c2340] rounded-2xl p-8 text-white" data-id="element-239" data-mp="1zwo55azb8ndi">
                <h3 className="text-xl font-bold mb-6" data-id="element-240" data-mp="1uy4mbjg0jrpd">Contact Information</h3>
                <ul className="space-y-6" data-id="element-241" data-mp="1pzjk5eh7axya">
                  <li className="flex items-start gap-4" data-id="element-242" data-mp="1pyi4sxt5jpar">
                    <Phone className="w-6 h-6 text-[#b87333] shrink-0" data-id="element-243" data-mp="1lxy8fwgekppo" />
                    <div data-id="element-244" data-mp="1m0100kx7eqwi">
                      <p className="font-semibold mb-1" data-id="element-245" data-mp="ek4nycwtga48">Call Us Directly</p>
                      <a href="tel:7146023634" className="text-slate-300 hover:text-white transition-colors" data-id="element-246" data-mp="eia1uv9t6byk">
                        (714) 602-3634
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-247" data-mp="2q5nb9wv53hx4">
                    <Mail className="w-6 h-6 text-[#b87333] shrink-0" data-id="element-248" data-mp="2v5ruhunfmqr1" />
                    <div data-id="element-249" data-mp="2zx9kjnnx36x8">
                      <p className="font-semibold mb-1" data-id="element-250" data-mp="2zyky2f75zt1j">Email Us</p>
                      <a href="mailto:info@aflowraingutters.com" className="text-slate-300 hover:text-white transition-colors" data-id="element-251" data-mp="34ww8ar1dg5ka">
                        info@aflowraingutters.com
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-252" data-mp="3iwnj6iwld5u2">
                    <Clock className="w-6 h-6 text-[#b87333] shrink-0" data-id="element-253" data-mp="3iu19acm8ae8o" />
                    <div data-id="element-254" data-mp="1jkujufmbzoe6">
                      <p className="font-semibold mb-1" data-id="element-255" data-mp="1jlns5l0xulyf">Business Hours</p>
                      <p className="text-slate-300" data-id="element-256" data-mp="1oimkby11kitz">
                        Mon - Fri: 8:00 AM - 5:00 PM
                      </p>
                      <p className="text-slate-300" data-id="element-257" data-mp="3meb55wuxt7uo">Sat - Sun: Closed</p>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-2xl p-8 border border-slate-200" data-id="element-258" data-mp="3ztxinqk1cac">
                <h3 className="text-lg font-bold text-[#0c2340] mb-3" data-id="element-259" data-mp="3v7oaxze3o3y6">
                  What happens next?
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-260" data-mp="37hc0agrgzt3w">
                  After you submit this form, our team will review your details
                  and contact you within 1 business day to schedule an on-site
                  evaluation. We'll take precise measurements and provide a
                  detailed, written estimate for your project.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}